import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../utils/AuthProvider";
import api from "../../../utils/api";
import { FaCrown } from "react-icons/fa";
import useClickOutside from "../../../hooks/useClickOutside";
import { PanelLeftOpen } from "lucide-react";

const HeaderDashboard = React.memo(
  ({
    userLevel,
    sidebarVisible,
    setSidebarVisible,
    dropdownOpen,
    setDropdownOpen,
    logout,
    openModal,
    wordCount,

    openSettings,
    darkMode,
  }) => {
    const tokenLimit = 5000;
    const usedTokens = Number(wordCount) || 0;
    const tokenProgress = Math.min(
      Math.max((usedTokens / tokenLimit) * 100, 0),
      100,
    );
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const [isSmallScreen, setIsSmallScreen] = useState(
      window.innerWidth <= 640,
    );

    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 640);
      };

      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
    const user = JSON.parse(sessionStorage.getItem("user"));

    useClickOutside(dropdownRef, buttonRef, () => setDropdownOpen(false));

    const toggleButton = () => {
      setDropdownOpen((prevState) => !prevState);
    };
    return (
      <header
        className={`py-1 px-4 flex flex-col overflow-hidden shadow-md ${
          darkMode ? "bg-slate-800 text-gray-100" : "bg-slate-50 text-gray-900"
        }`}>
        <div className="flex items-center justify-between w-full min-w-0">
          <div className="flex items-center">
            {!sidebarVisible && (
              <button
                className="p-1 mr-4 text-gray-900 sm:hidden dark:text-gray-100 hover:text-gray-300 dark:hover:text-gray-700"
                onClick={() => setSidebarVisible(!sidebarVisible)}>
                <PanelLeftOpen size={20} />
              </button>
            )}
            <img
              className="h-10"
              src="https://bethaibucket.s3.us-east-1.amazonaws.com/images/babylon.png"
              alt="Logo"
              style={{
                filter: darkMode ? "invert(1)" : "none",
              }}
            />
          </div>
          <div className="flex items-center flex-shrink-0 min-w-0 mr-4 text-gray-900 gap-x-2 dark:text-gray-100">
            {userLevel && userLevel !== "free" ? (
              <div className="flex items-center text-xs font-semibold text-green-700 gap-x-2 dark:text-green-400">
                <FaCrown size={20} />
                <span className="ml-1">Premium Member</span>
              </div>
            ) : userLevel === "free" ? (
              <>
                <img
                  className="max-h-5"
                  src="/coin.svg"
                  alt="coin"
                />
                <div
                  className="relative h-6 overflow-hidden border rounded-sm border-slate-600 bg-slate-200 dark:border-slate-500 dark:bg-slate-700"
                  style={{
                    width: 112,
                    minWidth: 112,
                    maxWidth: 112,
                    flexShrink: 0,
                  }}>
                  <div
                    className={`absolute top-0 left-0 h-full transition-all duration-300 ${
                      darkMode ? "bg-green-700" : "bg-green-500"
                    }`}
                    style={{ width: `${tokenProgress}%`, maxWidth: "100%" }}
                  />

                  <span className="relative flex items-center justify-center h-full min-w-0 px-1 overflow-hidden text-xs font-medium text-gray-700 whitespace-nowrap dark:text-white">
                    {usedTokens}/{tokenLimit}
                  </span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </header>
    );
  },
);

export default HeaderDashboard;

